import { Pipe, PipeTransform } from '@angular/core';
import * as g from 'src/app/globals';
import * as accounting from 'accounting';
@Pipe({
  name: 'amount',
})
export class AmountPipe implements PipeTransform {
  transform(value: any, decimals?: string): unknown {
    const companyConfiguration = g.companyConfiguration;
    if (companyConfiguration == null) {
      return value;
    }
    if (value === null || isNaN(value)) {
      value = 0;
    }

    if (decimals === undefined || decimals === '') {
      decimals = 'amount';
    }

    let decimalsCount = 6;
    if (decimals === 'amount') {
      decimalsCount = companyConfiguration.AmountDecimal;
    } else if (decimals === 'quantity') {
      decimalsCount = companyConfiguration.QuantityDecimal;
    } else if (decimals === 'price') {
      decimalsCount = companyConfiguration.PriceDecimal;
    } else if (decimals === 'percent') {
      return accounting.formatMoney(
        value,
        '%',
        companyConfiguration.PercentDecimal,
        '',
        companyConfiguration.DecimalSep,
        '%s %v'
      );
    } else if (decimals == 'time') {
      const timeVal = ('0000' + value.toString()).slice(-4);
      const hour = timeVal.charAt(0) + timeVal.charAt(1);
      const min = timeVal.charAt(2) + timeVal.charAt(3);
      return `${hour}:${min}`;
    }

    const returnValue = accounting.formatNumber(
      value,
      decimalsCount,
      companyConfiguration.ThousandSep,
      companyConfiguration.DecimalSep
    );
    return returnValue;
  }
}
